import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ValidateService {
  numericPattern: string = '^[0-9]+$';
  tenDigits ='^\\d{10}$';
    nifPattern: string =
    '(([A,B,C,D,E,F,G,H,J,U,V]\\d{8})|([P,Q,R,S,N,W]\\d{7}[A-Z]))';
  nimaPattern = '^(0[1-9]|[1-9][0-9])[0-9]{8}$';
  constructor() {}
}
